module.exports = __webpack_public_path__ + "static/img/01.c910d792.png";